import { MessagingBackend } from "@whatslly/commons/messagingBackend";
import { LOGIN_COMMANDS_PREFIX, LoginCommandTypes, LoginCommands } from "./loginCommands";

export const loginListener = new MessagingBackend<LoginCommandTypes>(LoginCommands, LOGIN_COMMANDS_PREFIX);
const handler = loginListener.getHandler((event: MessageEvent) => ({ request: event.data, respond: event.source?.postMessage }));
window.addEventListener("message", handler);
